<template>
  <vx-modal
    :title="
      !form.uuid ? $t('messages.create.title') : $t('messages.edit.title')
    "
    :active.sync="show"
  >
    <form @submit.prevent="save" @keydown="form.onKeydown($event)">

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vx-select
              :model.sync="form.category_faq_id"
              :label="$t('faqs.labels.category_faq_id')"
              :options="categories"
              :translate="false"
              :uuid="false"
              :placeholder="$t('faqs.labels.category_faq_id')"
            ></vx-select>

            <has-error :form="form" field="category_faq_id" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('faqs.labels.question')"
              name="question"
              class="w-full"
              v-model="form.question"
            />
            <has-error :form="form" field="question" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
             <vs-textarea
              :label="$t('faqs.labels.answer')"
              name="answer"
              class="w-full"
              v-model="form.answer"
              rows="3"
            />
            <has-error :form="form" field="answer" />
          </div>
        </div>
      </div>

      <div class="flex flex-wrap justify-between">
        <div class="mb-6 md:mb-0 mr-4"></div>

        <div class="mb-6 flex flex-wrap justify-between">
          <vs-button class="md:mb-0" v-if="!form.uuid" button="submit">
            {{ $t('messages.create.title') }}
          </vs-button>
          <vs-button class="md:mb-0" v-else button="submit">
            {{ $t('messages.edit.title') }}
          </vs-button>
        </div>
      </div>
    </form>
  </vx-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Form from 'vform'

export default {
  data() {
    return {
      form: new Form({
        uuid: null,
        question: '',
        answer: '',
        category_faq_id: ''
      }),
      categories: [],
      disableButton: false,
      show: false
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.clearForm()
      }
    }
  },
  computed: {
    getEmbedUrl: {
      get() {
        if (this.form.url !== '' && this.form.url != undefined) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
          const match = this.form.url.match(regExp)
          return match && match[2].length === 11 ? `//www.youtube.com/embed/${ match[2] }` : null
        } else {
          return null
        }
      }
    }
  },
  methods: {
    async showModal() {
      this.show = true
      await this.getCategories()
    },
    save() {
      if (this.form.uuid) {
        this.edit()
      } else {
        this.create()
      }
    },
    async create() {
      let message_title = null
      let message_content = null
      let message_type = null
      try {
        this.disableButton = true

        this.$vs.loading()

        await this.form.post(
          `${process.env.VUE_APP_API_URL}/api/faqs`
        )
        this.$parent.getFaqs()
        this.$vs.loading.close()

        message_type = 'success'
        message_content = this.$t(
          'messages.create.messages.success_description'
        )
        message_title = this.$t('messages.create.messages.success')
        this.showMessage(message_type, message_title, message_content)
        this.show = false
        this.clearForm()
      } catch (exception) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async edit() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        this.disableButton = true
        vm.$vs.loading()
        const { data } = await this.form.patch(
          `${process.env.VUE_APP_API_URL}/api/faqs/${this.form.uuid}`
        )

        this.$parent.getFaqs()
        this.$vs.loading.close()
        this.form = Object.assign(this.form, data)
        message_type = 'success'
        message_content = this.$t('messages.edit.messages.success_description')
        message_title = this.$t('messages.edit.messages.success')
        this.showMessage(message_type, message_title, message_content)

        this.show = false
        this.clearForm()
      } catch (exception) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      this.disableButton = false
    },
    async getFaq(uuid) {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/faqs/${uuid}`
        )
        this.form = _.assign(this.form, data)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    showMessage(message_type, message_title, message_content) {
      Swal.fire({
        icon: message_type,
        title: message_title,
        text: message_content,
        confirmButtonText: this.$t('ok')
      })
    },
    clearForm() {
      this.form = _.assign(this.form, {
        uuid: null,
        question: '',
        answer: '',
        category_faq_id: '',
        url: ''
      })
      this.form.clear()
    },
    async getCategories() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/faqs/categories`
        )
        this.categories = data.data
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    }
  }
}
</script>
